export enum PassoAutenticacaoEnum {
  Login,
  MfaToken,
  verificationCodeRequest,
  NovaSenha,
  ResetSenha,
}
